





























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { format } from 'date-fns';
import Menu from '@/components/common/Menu.vue';
import PrivateNetworkConnectedMachines from '@/components/network/private-network/PrivateNetworkConnectedMachines.vue';
import Logs from '@/components/common/Logs.vue';
import { privateNetworkService } from '@/components/network/private-network/services/PrivateNetworkService';
import { publicIPAddressService } from '@/components/network/public-ip-address/services/PublicIPAddressService';
import { mapState } from 'vuex';
import { storeService } from '@/services/StoreService';

@Component({
  components: {
    Menu,
    PrivateNetworkConnectedMachines,
    Logs,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class PrivateNetworkInfo extends Vue {
  isTabActive: number = 0;
  workspaceId: number = 0;
  regionId: number = 0;
  privateNetworkId: number = 0;
  privateNetworkType: string = '';
  privateNetwork = {
    id: 0,
    name: '',
    network: '',
    state: '',
    nics: [],
    dm_nics: [],
    public_ip_address: {
      id: '',
      ip_address: '',
    },
    type: '',
  };
  isRemoveModalShown = false;
  isEditingNameHidden = true;
  orginalName = '';
  isNameEmpty = false;
  isEditingOutputAddressHidden = true;
  publicIpAddressesForSelect = [];
  publicIpAddressId = '';
  orginalOutputAddress = '';
  machineType = '';
  isLoading = false;

  @Watch('$store.state.privateNetworks.private_networks', { immediate: true, deep: true })
  onNetworksChange(data: any) {
    if (data && this.privateNetworkId) {
      this.getNetworkFromStore();
    }
  }

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.privateNetworkId = parseInt(this.$route.params.privateNetworkId, 10);
    this.privateNetworkType = this.$route.params.privateNetworkType;
    storeService.getPrivateNetworks();
    this.getNetworkData();
    this.getPublicIpAddresses();
    throw new Error('Sentry Error');
  }
  getNetworkFromStore() {
    const data = this.$store.getters['privateNetworks/getPrivateNetwork'](this.privateNetworkId);
    if (data) {
      this.privateNetwork = { ...this.privateNetwork, ...data };
      this.orginalName = this.privateNetwork.name;
      this.orginalOutputAddress = this.privateNetwork.public_ip_address.ip_address;
      this.publicIpAddressId = this.privateNetwork.public_ip_address.id;
    }
  }
  getNetworkData() {
    privateNetworkService
      .getPrivateNetwork(this.workspaceId, this.regionId, this.privateNetworkId, this.privateNetworkType)
      .then((data: any) => {
        this.privateNetwork = data;
        this.orginalName = this.privateNetwork.name;
        this.orginalOutputAddress = this.privateNetwork.public_ip_address.ip_address;
        this.publicIpAddressId = this.privateNetwork.public_ip_address.id;
        this.machineType = this.privateNetwork.type.toLowerCase();
      })
      .catch(() => {});
  }
  getPublicIpAddresses() {
    publicIPAddressService.getPublicIPAddresses(this.workspaceId, this.regionId).then((data: any) => {
      this.publicIpAddressesForSelect = data.public_ip_addresses.filter((ip: any) => ip.state === 'idle');
    });
  }
  editName() {
    if (this.privateNetwork.name === '') {
      this.isNameEmpty = true;
    } else {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      privateNetworkService
        .editPrivateNetworkName(this.workspaceId, this.regionId, this.privateNetwork.id, this.privateNetworkType, {
          name: this.privateNetwork.name,
        })
        .then(() => {
          this.isLoading = false;
          this.isEditingNameHidden = true;
          this.orginalName = this.privateNetwork.name;
          this.privateNetwork = { ...this.privateNetwork };
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }
  cancelName() {
    this.isEditingNameHidden = !this.isEditingNameHidden;
    this.privateNetwork.name = this.orginalName;
    this.isNameEmpty = false;
  }
  editOutputAddress() {
    if (this.privateNetwork.name === '') {
      this.isNameEmpty = true;
    } else {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      privateNetworkService
        .updateOutputAddress(this.workspaceId, this.regionId, this.privateNetwork.id, this.privateNetwork.type, {
          public_ip_address_id: this.publicIpAddressId,
        })
        .then(() => {
          this.isLoading = false;
          this.isEditingOutputAddressHidden = true;
          this.orginalOutputAddress = this.privateNetwork.public_ip_address.ip_address;
          const selectedNet: any = this.publicIpAddressesForSelect.filter(
            (item: any) => parseInt(item.id, 10) === parseInt(this.publicIpAddressId, 10)
          )[0];
          this.privateNetwork.public_ip_address.ip_address = selectedNet.address;
          this.privateNetwork = JSON.parse(JSON.stringify(this.privateNetwork));
          this.getNetworkData();
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }
  cancelOutputAddress() {
    this.isEditingOutputAddressHidden = !this.isEditingOutputAddressHidden;
    this.privateNetwork.public_ip_address.ip_address = this.orginalOutputAddress;
  }
  onCloseRemoveModal() {
    this.isRemoveModalShown = false;
  }
  tabSelected(index: number) {
    this.isTabActive = index;
  }
  deletePrivateNetwork() {
    privateNetworkService
      .removePrivateNetwork(this.workspaceId, this.regionId, this.privateNetworkId, this.machineType)
      .then(() => {
        this.$router.push(`/workspaces/${this.workspaceId}/regions/${this.regionId}/private-networks`).catch(() => {});
      });
  }
}
